<template>
  <van-dialog
    className="dialog"
    v-model="mShow"
    :showConfirmButton="false"
    :closeOnClickOverlay="true"
  >
    <div class="content column">
      <img class="itemImg" :src="img" alt="" />
      <div class="subTitle">恭喜你</div>
      <div class="desc">{{ productDesc }}</div>
      <div class="btn" @click="close">开心收下</div>
    </div>

  </van-dialog>
</template>

<script>
const rewardPoint = require("../../assets/wheel/reward_point.png");
const rewardVip = require("../../assets/wheel/reward_vip.png");
const rewardVoice = require("../../assets/wheel/reward_voice.png");

export default {
  data() {
    return {
      mShow: false,
      img: "",
      productDesc: 0,
    };
  },

  mounted() {},

  methods: {
    /**
     * productType 商品类型：1 剪辑点 、 2 语音点 、 3 会员天数
     *  productNum 商品值 ,
     */
    open(productType, productNum) {
      if (productType === 1) {
        this.img = rewardPoint;
        this.productDesc = `获得${productNum}剪辑点`;
      } else if (productType === 2) {
        this.img = rewardVoice;
        this.productDesc = `获得${productNum}语音点`;
      } else if (productType === 3) {
        this.img = rewardVip;
        this.productDesc = `获得${productNum}天会员`;
      }
      this.productNum = productNum;
      this.mShow = true;
    },

    close() {
      this.mShow = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
@import url(../../css/main.css);

.content {
  height: 400px;
  background-image: url(../../assets/wheel/dialog_bg_normal.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

.dialog {
  background: none !important;
}

.itemImg {
  margin-top: 30px;
  width: 70px;
  object-fit: contain;
}
.subTitle {
  margin-top: 20px;
  font-family: Source Han Sans SC;
  font-weight: 800;
  font-size: 24px;
  color: #232323;
  line-height: 30px;
}

.desc {
  margin-top: 16px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 19px;
  color: #1a1a1a;
  line-height: 20px;
}

.btn {
  margin-top: 30px;
  width: 240px;
  height: 56px;
  background: linear-gradient(90deg, #70aaff 0%, #9362ff 100%);
  border-radius: 56px;
  font-size: 20px;
  color: #ffffff;
  line-height: 56px;
  font-weight: 700;
}
</style>